// ============================================================
// systems/fire.js — Fire effect (flames, embers, smoke)
// ============================================================
import { state } from '../state.js';
import { dom } from '../dom.js';

/**
 * Start the fire particle loop (flames, embers, smoke).
 */
export function startFireEffect() {
  if (state.fireInterval) return;
  state.fireInterval = setInterval(() => {
    // Spawn flame
    const flame = document.createElement('div');
    flame.className = 'flame';
    const size = 15 + Math.random() * 25;
    flame.style.width = size + 'px';
    flame.style.height = size * 1.3 + 'px';
    flame.style.left = (10 + Math.random() * 140) + 'px';
    flame.style.bottom = (Math.random() * 40) + 'px';
    const hue = Math.random() * 40; // 0=red, 20=orange, 40=yellow
    flame.style.background = `radial-gradient(ellipse, hsla(${hue}, 100%, 65%, 0.9), hsla(${hue - 10}, 100%, 45%, 0.6), transparent)`;
    flame.style.animationDuration = (0.6 + Math.random() * 0.6) + 's';
    dom.fireWrap.appendChild(flame);
    setTimeout(() => flame.remove(), 1200);

    // Spawn ember sparks
    if (Math.random() > 0.4) {
      const ember = document.createElement('div');
      ember.className = 'ember';
      ember.style.left = (20 + Math.random() * 120) + 'px';
      ember.style.bottom = (20 + Math.random() * 30) + 'px';
      ember.style.background = `hsl(${Math.random() * 30 + 10}, 100%, 60%)`;
      ember.style.setProperty('--ex', (Math.random() - 0.5) * 60 + 'px');
      ember.style.animationDuration = (0.8 + Math.random() * 0.8) + 's';
      dom.fireWrap.appendChild(ember);
      setTimeout(() => ember.remove(), 1600);
    }

    // Spawn smoke
    if (Math.random() > 0.7) {
      const smoke = document.createElement('div');
      smoke.className = 'smoke';
      const sSize = 20 + Math.random() * 20;
      smoke.style.width = sSize + 'px';
      smoke.style.height = sSize + 'px';
      smoke.style.left = (30 + Math.random() * 100) + 'px';
      smoke.style.bottom = '60px';
      smoke.style.background = `rgba(80, 80, 80, 0.3)`;
      smoke.style.animationDuration = (1.5 + Math.random() * 1) + 's';
      dom.fireWrap.appendChild(smoke);
      setTimeout(() => smoke.remove(), 2500);
    }
  }, 80);
}

/**
 * Stop fire and clear all fire elements.
 */
export function stopFireEffect() {
  clearInterval(state.fireInterval);
  state.fireInterval = null;
  dom.fireWrap.innerHTML = '';
}
